export const questionWords: { [language: string]: string[] } = {
	en: [
		'who',
		'what',
		'when',
		'where',
		'why',
		'is',
		'how',
		'which',
		'do',
		'does',
		'are',
		'can',
		'does',
		'would',
		'will',
		'could',
		'should',
		'did',
		'has',
		'have',
		'was',
	],
	de: ['wer', 'was', 'wann', 'wo', 'warum', 'wie', 'welcher', 'wieviel'],
	ru: [
		'что',
		'когда',
		'где',
		'почему',
		'как',
		'какова',
		'кто',
		'какой',
		'сколько',
		'зачем',
		'откуда',
		'куда',
	],
	fr: [
		'qui',
		'quoi',
		'où',
		'quand',
		'pourquoi',
		'comment',
		'combien',
		'lequel',
		'quel',
		'quelle',
		'quels',
		'quelles',
	],
	pt: ['que', 'quem', 'onde', 'quando', 'como', 'quanto', 'qual'],
	cs: ['kdo', 'co', 'kdy', 'kde', 'proč', 'jak', 'kolik', 'který'],
	el: ['τι', 'ποιος', 'ποια', 'ποιο', 'πότε', 'πού', 'πώς', 'γιατί', 'πόσο'],
	'zh-cn': ['什么', '谁', '哪里', '为什么', '何时', '怎么', '哪', '多少'],
	'zh-sg': ['什么', '谁', '哪里', '为什么', '何时', '怎么', '哪', '多少'],
	'zh-hk': ['什麼', '為什麼', '在哪裡', '何時', '誰', '哪一個', '如何', '多少'],
	'zh-mo': ['什麼', '為什麼', '在哪裡', '何時', '誰', '哪一個', '如何', '多少'],
	'zh-tw': ['什麼', '為什麼', '在哪裡', '何時', '誰', '哪一個', '如何', '多少'],
	ja: ['何', 'なに', '誰', 'だれ', 'どこ', 'どうして', 'いつ', 'どの', 'いくつ', 'どれ'],
	ko: ['무엇', '뭐', '어디', '언제', '왜', '누구', '어떻게', '몇', '어느'],
};
